function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { defineComponent, computed } from "vue";
import { getFlagEmoji } from "@com/config/ai-support-language";
import { definePropType } from "@types-vue/props";
import { IconResolverProp } from "./props";
export default defineComponent({
    props: _objectSpread({
        language: {
            type: definePropType(Object),
            required: true
        },
        // 是否显示code
        showCode: {
            type: Boolean,
            default: false
        }
    }, IconResolverProp),
    setup: function setup(props) {
        var icon = computed(function() {
            var code = props.language.code && props.language.code.substring(props.language.code.indexOf("-") + 1).toLowerCase();
            return props.resolver ? props.resolver(code) : getFlagEmoji(code);
        });
        return {
            icon: icon
        };
    }
});
